import clsx from 'clsx'

interface MeasurementInputProps {
  value: string
  onChange: (value: string) => void
  unit: string
  placeholder?: string
  className?: string
}

export function MeasurementInput({
  value,
  onChange,
  unit,
  placeholder,
  className,
}: MeasurementInputProps) {
  return (
    <div className={clsx('flex w-full', className)}>
      <div className="border-custom-gray relative flex-1 rounded-l-[20px] border border-r-0 bg-white">
        <input
          data-testid="textfield"
          type="number"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder || ''}
          className="w-full border-none bg-transparent py-6 text-center text-3xl placeholder:text-[#ACACAC] focus:outline-none"
          min="0"
          step="0.1"
          required
        />
      </div>
      <div className="border-custom-gray flex w-24 items-center justify-center rounded-r-[20px] border border-l-1 border-l-[#ACACAC] bg-white text-3xl font-semibold text-black">
        {unit}
      </div>
    </div>
  )
}

interface UnitToggleProps {
  units: string[]
  selectedUnit: string
  onUnitChange: (unit: string) => void
  className?: string
}

export function UnitToggle({
  units,
  selectedUnit,
  onUnitChange,
  className,
}: UnitToggleProps) {
  return (
    <div className={clsx('flex gap-2', className)}>
      {units.map((unit) => (
        <button
          key={unit}
          type="button"
          onClick={() => onUnitChange(unit)}
          className={clsx(
            'rounded-3xl px-8 py-3 text-base font-bold transition-colors',
            selectedUnit === unit
              ? 'bg-black text-white'
              : 'border border-[#ACACAC] bg-white text-[#ACACAC] hover:text-[#ACACAC]',
          )}
        >
          {unit}
        </button>
      ))}
    </div>
  )
}
